<template>
  <div class="login">
    <span class="fanhui" @click="$router.back()"><i class="iconfont icon-left"></i>Return</span>
    <div class="login_content">
      <div class="login_img">
        <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/footer_home/footerLogo.png" alt=""/>
      </div>
      <div class="email_login">
        <el-form :model="emailRuleForm" status-icon ref="emailLogin" class="demo-ruleForm" label-width="50px">
          <el-form-item prop="email"
            :rules="[ { required: true, message: 'Please enter email', trigger: 'blur' },
              { type: 'email', message: 'Input email address', trigger: ['blur', 'change'] } ]"
          >
            <el-input class="inoput_underline" v-model="emailRuleForm.email" placeholder="Please enter email"></el-input>
            <img class="login_icon" src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/login/email.png" alt=""/>
          </el-form-item>
          <el-form-item prop="password" :rules="[{ required: true, message: 'Please enter password', trigger: 'blur' }]" >
            <el-input type="password" class="inoput_underline" placeholder="Please enter password" v-model="emailRuleForm.password" autocomplete="off" show-password></el-input>
            <img class="login_icon" src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/login/password.png" alt=""/>
          </el-form-item>
          <p class=" retrieve_password">
            <span @click="retrievePass">Forgot Password?</span>
          </p>
          <el-form-item prop="type" :rules="[{ required: true, message: 'Please fully read and agree to the agreement above', trigger: 'blur' }]" class="login_type">
             <el-checkbox-group v-model="emailRuleForm.type">
              <el-checkbox label="" name="type"> I have read and agreed to<span class="agreement" @click.stop="agreement(true)">《Terms of Use》</span><br/>and<span class="agreement" @click.stop="agreement(false)">《Privacy Policy》</span></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item class="login_button" >
            <el-button class="" @click="changeLogin('emailLogin')">Log in</el-button>
          </el-form-item>
          <p class="new_email">
            No account yet?<span @click="registered">Register</span>
          </p>
        </el-form>
      </div>
    </div>  
    <div v-if="popup" class="c_mask">
      <div class="c_wrap">
        <img @click="popup = false" src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/close.png" />
        <div>
          <div class="c_title">{{vessel.title}}</div>
          <div class="c_content">
            <div>
              <p v-for="(item,i) in vessel.arr" :key="i">{{item}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "mint-ui/lib/header/style.css"
import { reqLoginEn } from "../../../api";
import { privacy_policy, terms_of_use } from "../../../mock/country";
import { Toast, } from 'mint-ui';
export default {
  component:{
    // 'mt-header':Header.name
  },
  data(){
    return{
      emailRuleForm:{
        email:'',
        password:'',
        state:'',
        type:''
      },
      popup:false,
      vessel:{
        title:'',
        arr:[]
      }
    }
  },
  methods:{
    async changeLogin(formName){//登录请求
      this.$refs[formName].validate( async (valid) => {
        if (valid) {//提交表单数据，发送请求
          const response = await reqLoginEn(this.emailRuleForm)
          // console.log(response);
          if (response.code*1==1) {
            // response.resilt
            this.$store.dispatch('userInformation',response.resilt)
            this.$store.dispatch('isLogin',1)
            this.$router.push('/')
          }else{
            Toast({position: 'top',message: 'login failed'})
          }
        } else {
          return false;
        }
      });
    },
    retrievePass(){//忘记密码
      this.$router.push('/retrievePass')
    },
    agreement(falg){//协议跳转
      if (falg) {
        this.popup = true
        this.vessel = terms_of_use
      }else{
        this.popup = true
        this.vessel = privacy_policy
      }
    },
    registered(){//注册
      this.$router.push('/registered/2')
    },
  }
}
</script>

<style scoped>
  .login{
    position: relative;
    height: 100%;
    width: 100%;
    z-index: 1;
    background-color: white;
    background-image: url('https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/login/login_bg.png');
    background-size: 100% 100%;
  }
  .fanhui{
    line-height: 30px;
    color: #b8b8b8;
    font-size: 14px;
    padding-left: 10px;
  }
  .login_content{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    width: 100%;
    max-height: 540px;
    /* background-color: yellowgreen; */
    height: 100%;
  }
  .login_img{
    max-width: 180px;
    margin: auto;
    padding: 60px 0 40px;
  }
  .email_login{
    padding: 20px 40px;
  }
  .login_icon{
    position: absolute;
    left: -46px;
    top: 4px;
    margin-top: 4px;
    width: 32px;
    height: 32px;
  }
  .email_login p{
    font-size: 12px;
    color: #b8b8b8;
    text-align: end;
  }
  .retrieve_password{
    margin-top: -5px;
  }

  .email_login .new_email{
    text-align: center;
  }
  .new_email span{
    color: #fae655;
  }
  #app .login >>> .el-input.is-active .el-input__inner,#app .login >>> .el-input__inner:focus{
    border-color: #fae655;
  }
  .login_type{
    margin-top: 30px;
    margin-left: -40px;
    font-size: 12px;
  }
  .login_type>>> .el-form-item__content{
    font-size: 12px;
    line-height: 20px;
  }
  .login_type>>> .el-form-item__content span{
    font-size: 12px;
    vertical-align: top;
  }
  .agreement{
    color: #d6c751;
  }
  .login_button{
    margin-left: -50px;
  }
  .login_button button{
    width: 100%;
    border-radius: 20px;
    background-image: linear-gradient(#fffa81,#f2c409);
    border: none;
    color: white;
    font-weight: 600;
  }
  .login_button button:focus{
    color: white;
  }
</style>
<style>
  .inoput_underline input{
    background-color: transparent;
    border-radius: 0;
    border: none;
    border-bottom: 1px solid #aaa;
    padding: 0 6px;
    color: white;
  }
  .inoput_underline input:focus,
  .inoput_underline input:hover{
    border-color: #aaa;
  }
  
</style>
<style scoped>
  .c_mask{
    position: fixed;
    overflow: auto;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(55,55,55,.6);
    outline: 0;
    z-index: 3000;
  }
  .c_wrap{
    margin: 0 auto;
    position: relative;
    top: 100px;
    outline: 0;
    /* background-color: white; */
    width: 100%;
    max-width: 500px;
    padding: 10px;
  }
  .c_wrap>img{
    z-index: 1;
    position: absolute;
    right: 18px;
    top: 18px;
    width: 30px;
    height: auto;
  }
  .c_wrap>div{
    background-color: white;
  }
  .c_title{
    margin: 0 30px;
    padding: 16px;
    text-align: center;
    border-bottom: 1px solid  #e2e2e2;
    font-size: 18px;

  }

  .c_content{
    padding: 24px 30px;
    font-size: 12px;
    line-height: 1.5;
  }
  .c_content>div{
    padding-right: 8px;
    max-height: 260px;
    overflow-y: auto;
  }
  .c_content p{
    text-align: justify;
    margin-bottom: 10px;
    word-break: normal;
    line-height: 24px;
  }
  
</style>